import type {
  NextMonthButtonProps,
  PreviousMonthButtonProps,
} from 'react-day-picker';

import { VIconButton } from '../VIconButton';
import { ChevronLeft, ChevronRight } from '../asset';

const VDatePickerMoveMonthButton = ({
  dir,
  ...rest
}: (NextMonthButtonProps | PreviousMonthButtonProps) & {
  dir: 'next' | 'prev';
}) => {
  return (
    <VIconButton
      {...rest}
      variant="roundSecondary"
      Icon={dir === 'next' ? ChevronRight : ChevronLeft}
      onClick={e => {
        e.stopPropagation();
        rest.onClick?.(e);
      }}
    />
  );
};

export default VDatePickerMoveMonthButton;
